import React, { useState, useEffect } from "react";

import i18n from "i18n-react";
import PropTypes from "prop-types";

import { LoginForm, LanguageSelect, StoreButtons, StorageHandler } from "C4";

import CompanyLogo from "assets/images/companylogo.png";
import { googleStore, appleStore, storageKeys } from "settings";
import apple from "assets/images/app_store.png";
import google from "assets/images/google_play.png";

const MobileButtons = () => (
  <div className="button__container">
    <div className="buttons small">
      <a href={appleStore} target="_blank" rel="noopener noreferrer">
        <img src={apple} alt="App store" />
      </a>
      <a href={googleStore} rel="noopener noreferrer">
        <img src={google} alt="Google Play" />
      </a>
    </div>
  </div>
);

const LoginView = (props) => {
  const [logo, setLogo] = useState(null);

  const getAppInfo = async () => {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      setLogo(appInfo.logo);
    }
  };

  useEffect(() => {
    getAppInfo();
  }, []);

  return (
    <div className="loginView">
      <div className="loginView__bg">
        <div className="loginView__bg--content">
          <img src={CompanyLogo} alt="Company Logo" />
          <h3>{i18n.translate("loginScreen.title")}</h3>
          <div className="buttonWrapper">
            <MobileButtons />
          </div>
        </div>
      </div>
      <div className="loginView__content">
        {logo && <img src={logo} className="loginView__content--logo" alt="Logo" />}
        <LoginForm path={props.match.path} />
      </div>
      <style>
        {
          "\
    #openWidget { display: block; bottom: 4rem; } "
        }
      </style>
      {/* {props.showLanguageDropdown && <LanguageSelect />} */}
    </div>
  );
};

export default LoginView;

LoginView.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }),
  showLanguageDropdown: PropTypes.bool,
};

LoginView.defaultProps = {
  match: {
    path: "/login",
  },
  showLanguageDropdown: true,
};
